import posthog from "posthog-js";

/**
 * PostHog wiring for the site.
 *
 * `initAnalytics` runs once from gatsby-browser.js. It deliberately starts the
 * SDK in a dormant state — nothing is captured and nothing is written to browser
 * storage — until the visitor makes a choice in the cookie banner (GDPRCheck),
 * which calls `grantAnalyticsConsent` or `revokeAnalyticsConsent`.
 */

const POSTHOG_KEY =
  process.env.GATSBY_POSTHOG_KEY || "phc_s5iANuL2HZLCsM9dpCuZRXMHsL5pFgVfQFBtjvTpS29p";
const POSTHOG_HOST = process.env.GATSBY_POSTHOG_HOST || "https://eu.i.posthog.com";

const isBrowser = typeof window !== "undefined";

// Keep local browsing out of the production project. Set GATSBY_POSTHOG_ENABLE_DEV=true
// in .env.development if you need to verify events while running `yarn develop`.
const enabled =
  isBrowser &&
  Boolean(POSTHOG_KEY) &&
  (process.env.NODE_ENV === "production" ||
    process.env.GATSBY_POSTHOG_ENABLE_DEV === "true");

let initialised = false;

export const initAnalytics = () => {
  if (!enabled || initialised) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // Dated snapshot of PostHog's defaults. Among other things this sets
    // capture_pageview to 'history_change', so Gatsby's client-side route
    // changes are captured automatically (no manual onRouteUpdate needed),
    // and injects PostHog's own scripts into <head> to avoid hydration warnings.
    defaults: "2026-05-30",
    // Both flags are needed to stay silent until consent: opting out of capturing
    // on its own still lets PostHog write its localStorage entry and cookie.
    opt_out_capturing_by_default: true,
    opt_out_persistence_by_default: true,
  });

  initialised = true;
};

export const grantAnalyticsConsent = () => {
  if (!initialised) return;
  // PostHog persists the opt-in itself, so on a return visit it is already
  // capturing by the time the banner logic re-applies consent. Opting in again
  // would capture a second $pageview for the same page.
  if (posthog.get_explicit_consent_status() === "granted") return;
  // Captures $opt_in plus the pageview for the page the banner was accepted on,
  // which was dropped while the SDK was dormant.
  posthog.opt_in_capturing();
};

export const revokeAnalyticsConsent = () => {
  if (!initialised) return;
  posthog.opt_out_capturing();
};
